// extracted by mini-css-extract-plugin
export var trial_static_hide = "free-trial-module--trial_static_hide--ukIH-";